export const USAGE_CLUSTER_RADIUS = 100;

export const usageClusterRenderer = {
  render: ({ count, position }) => {
    const svg = window.btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42">
        <circle cx="21" cy="21" r="19" fill="#D7E8ED" opacity="0.8" stroke="#1D2946" stroke-width="1" />
        <text x="21" y="26" text-anchor="middle" font-size="14" font-family="Arial" fill="#596A99">${count}</text>
      </svg>
    `);
    const img = document.createElement('img');
    img.src = `data:image/svg+xml;base64,${svg}`;
    img.width = 42;
    img.height = 42;

    return new window.google.maps.marker.AdvancedMarkerElement({
      position,
      content: img,
      zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
      gmpClickable: true,
    });
  },
};
